"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SignOutIcon = function SignOutIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M15 1v14H6v-2h.998a1 1 0 0 0 .707-1.707L6.412 10H11a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H6.412l1.293-1.293A1 1 0 0 0 6.998 3H6V1zM1 8l3.998 4h2l-3-3H11V7H3.998l3-3h-2z"
    }) : _react["default"].createElement("path", {
      d: "M15 1v14H6v-5h1v4h7V2H7v5H6V1zm-4 7H2.773l1.58-1.581-.706-.707-2.81 2.81 2.81 2.808.706-.707L2.73 9H11z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M22 1v22H7v-5h1.828a1 1 0 0 0 .707-1.707L7.243 14h5.706a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H7.241l2.292-2.293A1 1 0 0 0 8.826 6H7V1zM1 12l5 5h2.828L4.83 13h8.121v-2H4.826l4-4H6z"
    }) : _react["default"].createElement("path", {
      d: "M22 1v22H7v-9h1v8h13V2H8v9H7V1zm-7 11H2.621l2.661-2.661-.707-.707-3.833 3.833 3.89 3.89.708-.707L2.69 13H15z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M29 2v28H10v-7h1.436a1 1 0 0 0 .707-1.707L10 19.15V19h8.333a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H10v-.15l2.144-2.143A1 1 0 0 0 11.437 10H10V2zm-17.564 9H7.5L2 16.499 7.502 22h3.934l-4-4h10.898v-3H7.437z"
  }) : _react["default"].createElement("path", {
    d: "M29 2v28H10V18h1v11h17V3H11v12h-1V2zm-7 15v-1H3.741l3.614-3.663-.71-.703-4.835 4.9 4.837 4.806.705-.71L3.698 17z"
  }));
};

var _default = SignOutIcon;
exports["default"] = _default;